export let eventArray = [
  {
    id: 0,
    name: "Wallace James",
    location: "Abuja, Nigeria",
    date: "03 JUNE",
    title: `The next conference 23'`,
    price: "$10.00",
    image: "/images/image 15.svg",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/eventcreator_3.svg",
  },

  {
    id: 1,
    name: "Mirable Kalu",
    location: "Uyo, Nigeria",
    date: "03 JUNE",
    title: "Devfest",
    price: "FREE",
    image: "/images/event_image4.png",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/eventcreator_2.svg",
  },

  {
    id: 2,
    name: "Annabel Richard",
    location: "Lagos, Nigeria",
    date: "03 JUNE",
    title: "Sip and Pant NG at RadisonBlu",
    price: "FREE",
    image: "/images/event_image3.svg",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/eventcreator_1.svg",
  },
];

export let remainEvents = [
  {
    id: 0,
    heading: "Sport Events",
    name: "Bethel.K.",
    location: "Lagos",
    date: "03 JUNE",
    title: "Goalfest 2023",
    price: "$10.00",
    image: "/images/event_image2.svg",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/eventcreator_4.svg",
  },
  {
    id: 2,
    name: "Wade Oliver",
    location: "Lagos",
    date: "03 JUNE",
    title: "Swimming Trainings",
    price: "FREE",
    image: "/images/event_image1.svg",
    mapline: "/images/MapPinLine.svg",
    icon: "/images/eventcreator_5.svg",
  },
];
